var _rect, _rect2, _rect3, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressStudys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.9521,
    width: 4.19048,
    height: 3.04762,
    rx: 1,
    fill: "#757A88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.71436,
    y: 11.8096,
    width: 4.19048,
    height: 4.19048,
    rx: 1,
    fill: "#757A88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4287,
    y: 11.0479,
    width: 4.19048,
    height: 4.95238,
    rx: 1,
    fill: "#757A88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.95247,
    cy: 1.33333,
    r: 1.33333,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42846 4.59908V6.17739C7.42846 6.24876 7.41318 6.3193 7.38366 6.38427L6.54583 8.22771C6.50059 8.32725 6.42431 8.40908 6.32793 8.46072C5.76732 8.76108 4.93395 9.19976 4.37879 9.47064C4.02125 9.64509 3.58042 9.85392 3.49964 10.2435C3.43697 10.5457 3.56387 10.8162 3.73923 10.9986C3.97828 11.2472 4.35349 11.1669 4.66947 11.0287L7.11738 9.95772C7.19644 9.92314 7.2652 9.86868 7.31697 9.79965L8.67672 7.98665C8.83254 7.77888 9.12149 7.72501 9.34172 7.86265L10.3409 8.48712C10.4288 8.54209 10.4975 8.62306 10.5374 8.71881L11.3019 10.5536C11.3841 10.7509 11.5239 10.9261 11.7223 11.0056C12.5126 11.3221 12.7879 10.7066 12.7684 10.3474C12.7662 10.3062 12.7534 10.2668 12.7369 10.229L11.4758 7.3464C11.4447 7.27531 11.3974 7.21243 11.3378 7.16274L10.4655 6.43561C10.3515 6.34061 10.2856 6.1999 10.2856 6.05153V4.53222C10.2856 4.2438 10.5299 4.01524 10.8173 3.99158C11.8486 3.90668 13.2325 3.43966 13.7142 2.47632C14.4995 0.905604 13.096 0.641854 12.7618 1.14299C12.3809 1.71424 12.196 2.66664 8.95227 2.66664C5.71418 2.66664 5.52371 3.23824 4.19037 3.99997C2.76753 4.81283 3.9999 5.90496 4.7618 5.3333C5.68592 4.63993 6.30784 4.3167 6.84732 4.14318C7.14429 4.04766 7.42846 4.28712 7.42846 4.59908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressStudys);
export default __webpack_public_path__ + "static/media/progress_studys.ae53c54a58a42b7e3c4377963db949a4.svg";
export { ForwardRef as ReactComponent };